module.exports = __webpack_public_path__ + "static/media/mythe.f14bc1e9.png";